import React, { useState, useEffect } from 'react';
import './Navbar.css';
import '../../../Responsive.css';
// import { createPopup } from '@typeform/embed'; // Ensure proper import
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function HeaderNavbar({ modalContainer, contactUrl, legacyNavigation = false } = {}) {

   // StartUp Modal
   const [modalShow, setModalShow] = React.useState(false);

   function ContactUs(props) {
    return (
      <Modal
        {...props}
        container={modalContainer}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contact_us_modal "
      >
         <Modal.Header closeButton className="border-0">
        {/* <Modal.Title id="contained-modal-title-vcenter">
        Startups
        </Modal.Title> */}
      </Modal.Header>
        <Modal.Body>
        <div className="contact-container">
      <h3>Contact Us</h3>
      <div className="contact-cards">
        <div className="contact-card">
          <h2>Chat to Sales</h2>
          <p>Speak to our friendly team</p>
          <a href="mailto:info@brewyourbran">info@brewyourbrand.in</a>
        </div>
        <div className="contact-card">
          <h2>Call Us</h2>
          <p>Mon - Sat from 10am to 7pm</p>
          <p className="phone-number">91 8150 00 22 55</p>
        </div>
      </div>
    </div>
        </Modal.Body>
      
      </Modal>
    );
  }

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Ensure Typeform embed script is loaded
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className={legacyNavigation ? "byb-nav" : "byb-nav byb-updated-menu"}>

    

        <Navbar
          collapseOnSelect
          expand="lg"
          className="new_byb top_header "
          expanded={isMenuOpen} // Sync expanded state
          onToggle={(expanded) => setIsMenuOpen(expanded)} // Update state on toggle
        >
          <span className='blur'></span>
          <Container>
            <Navbar.Brand href="/">
              <img
                src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"
                alt="BYB Logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav navbar-static-top">
              {legacyNavigation ? (
<Nav>
              <Nav.Link href="https://brewyourbrand.in/">About Us</Nav.Link>
              <Nav.Link  href="https://brewyourbrand.in/e-magazine/">eMagazine</Nav.Link>

                <Nav.Link  href="https://brewyourbrand.in/quick-brand-assessment/">Get a Quick Brand Assessment</Nav.Link>
                <Nav.Link href="https://brewyourbrand.in/brandselfauditkit">Brand Self-Audit Kit</Nav.Link>
                {/* <Nav.Link  href="">Join Community </Nav.Link> */}
                {/* <Nav.Link  href="https://course.brewyourbrand.in/services/learning">Complete Brand Series </Nav.Link> */}
                {/* <Nav.Link  href="">Subscribe</Nav.Link> */}
                <Nav.Link href="https://course.brewyourbrand.in/services/learning" >Learning</Nav.Link>

                <Nav.Link href="" onClick={() => setModalShow(true)}>Contact Us</Nav.Link>
                <Nav.Link href="https://chat.whatsapp.com/CTkM6q19Ltc3Btg5t6VcLZ" >Join Community</Nav.Link>

                  {/* <div className='type_form_btn'>
                      <div data-tf-live="01JJV14J257ED52SCENJ77441Y" style={{ width: '100%'}}></div>
                                
                  </div> */}
                {/* <div data-tf-live="01JJV14J257ED52SCENJ77441Y"></div><script src="//embed.typeform.com/next/embed.js"></script> */}
 
              </Nav>
) : (
<Nav>
                <Nav.Link href="https://brewyourbrand.in/gifting/">Brand Gifting</Nav.Link>
                <Nav.Link href="https://brewyourbrand.in/discovery-call/">Book a Discovery Call</Nav.Link>
                <Nav.Link href="https://brewyourbrand.in/brand-workshop/">Brand Workshop</Nav.Link>
                <Nav.Link href="https://brewyourbrand.in/e-magazine/">eMagazine</Nav.Link>
                <Nav.Link href="https://brewyourbrand.in/quick-brand-assessment/">Get a Quick Brand Assessment</Nav.Link>
                <Nav.Link href="https://brewyourbrand.in/brandselfauditkit">Brand Self-Audit Kit</Nav.Link>
                <Nav.Link href="https://course.brewyourbrand.in/services/learning">How to Build a Brand?</Nav.Link>
                {contactUrl ? (
                  <Nav.Link href={contactUrl} target="_blank" rel="noopener noreferrer">Contact Us</Nav.Link>
                ) : (
                  <Nav.Link as="button" type="button" onClick={() => setModalShow(true)}>Contact Us</Nav.Link>
                )}
              </Nav>
)}
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

      <ContactUs
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default HeaderNavbar;
